import React from 'react';

import { Virtual, Navigation, Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import '../css/ourServices.css';
import data from '../../../../data/layouts/services';

import 'swiper/css';
import 'swiper/css/navigation';

const OurServices = () => {
  return (
    <section
      className="services py-md-5 lazy-bg skeleton loaded"
      data-bg="url(./images/types-of-training.png)"
      style={{
        backgroundImage: "url('./images/types-of-training.png')",
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <div className="container">
        <h2 className="default-box-title text-center">
          CÁC DỊCH VỤ CỦA CHÚNG TÔI
        </h2>
        <Swiper
          modules={[Virtual, Navigation, Autoplay]}
          slidesPerView={1}
          slidesPerGroup={1}
          spaceBetween={30}
          navigation={true}
          virtual
          centeredSlides={false}
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
          }}
          breakpoints={{
            0: {
              slidesPerView: 1,
            },
            576: {
              slidesPerView: 1,
            },
            768: {
              slidesPerView: 2,
            },
            1024: {
              slidesPerView: 4,
            },
          }}
        >
          {data.map((service, index) => (
            <SwiperSlide key={index} virtualIndex={index}>
              <div>
                <div className="text-center position-relative lazy-container">
                  <div
                    className="skeleton"
                    style={{ height: '300px', display: 'none' }}
                  ></div>
                  <img
                    data-src={service.image}
                    className="mw-100 lazy-img loaded"
                    alt=""
                    loading="lazy"
                    src={service.image}
                    style={{
                      width: '100%',
                      aspectRatio: '1/1',
                      objectFit: 'cover',
                    }}
                  />
                </div>

                <h3 className="text-center">
                  <a href={service.link} title={service.title}>
                    {service.title}
                  </a>
                </h3>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        <div className="text-center mt-lg-5 mt-4">
          <span
            onClick={() =>
              document
                .getElementById('enrollment')
                ?.scrollIntoView({ behavior: 'smooth' })
            }
            className="btn"
            onclick="jump('enrollment-form')"
          >
            Đăng ký nhận tư vấn
          </span>
        </div>
      </div>
    </section>
  );
};

export default OurServices;
